export var ServiceIdentityStatus;
(function (ServiceIdentityStatus) {
    ServiceIdentityStatus["ACTIVE"] = "active";
    ServiceIdentityStatus["PENDING"] = "pending";
    ServiceIdentityStatus["CONSUMED"] = "consumed";
    ServiceIdentityStatus["EXPIRED"] = "expired";
})(ServiceIdentityStatus || (ServiceIdentityStatus = {}));
